import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Keyboard } from '@capacitor/keyboard';
import { ModalController, IonList, IonLabel, IonItem, IonInput, IonButton } from '@ionic/angular/standalone';

@Component({
    selector: 'app-missing-name',
    templateUrl: './missing-name.component.html',
    styleUrls: ['./missing-name.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonList,
        IonLabel,
        IonItem,
        IonInput,
        IonButton
    ]
})
export class MissingNameComponent implements OnInit {

    userName = ""
    constructor(
        private modalController: ModalController
    ) { }

    ngOnInit() { }

    save() {
        this.modalController.dismiss({
            userName: this.userName
        })
    }

    async dismissKeyboard(event: KeyboardEvent) {
        if (event && event.key === "Enter") {
            await Keyboard.hide()
        }
    }
}
